module.exports = __webpack_public_path__ + "img/error.e69ee806.svg";